// Copyright (c) 2022 by Move Closer

import { ModulesFormRegistryEntry } from '../../../contexts'

import { selenaFormFactory } from '../SelenaForm.factory'
import { SelenaFormModuleVersion } from '../SelenaForm.config'

/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
export const selenaFormModuleEntry: ModulesFormRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "form/core" */ './SelenaForm.form.vue'
  ),
  factory: selenaFormFactory,
  icon: require('../newsletter.svg'),
  label: 'modulesForms.SelenaForm._name',
  versions: {
    [SelenaFormModuleVersion.Webinar]: 'modulesForms.SelenaForm.versions.webinar',
    [SelenaFormModuleVersion.NewTrainingDates]: 'modulesForms.SelenaForm.versions.newTrainingDates',
    [SelenaFormModuleVersion.InviteToSite]: 'modulesForms.SelenaForm.versions.inviteToSite',
    [SelenaFormModuleVersion.IssueCertificate]: 'modulesForms.SelenaForm.versions.issueCertificate'
  }
}
